gsap.registerPlugin(ScrollTrigger);
// ==================================================================================== SECTION 2
(function() {
  'use strict';
  
  // Prevent multiple initializations
  let isInitialized = false;
  
  // Wait for DOM and Flickity to be ready
  function initFlickityEnhancements() {
    try {
      // Prevent multiple initializations
      if (isInitialized) {
        return;
      }
      
      // Check if Flickity exists
      if (typeof Flickity === 'undefined') {
        return;
      }

      // Check if the slider element exists
      const sliderElement = document.querySelector('.co-home-2-slider');
      if (!sliderElement) {
        return;
      }

      const flkty = new Flickity('.co-home-2-slider', {
        // autoPlay: 2500,
        pageDots: false, 
        selectedAttraction: 0.01,
        friction: 0.2,
        wrapAround: true,
        draggable: true,
        prevNextButtons: true
        // arrowShape: ''
      });

      // Mark as initialized after successful Flickity creation
      isInitialized = true;

      // Configuration - change these classnames as needed
      const SCALE_TARGET_CLASS = '.co-home-2-cell-frame';
      const TRANSLATE_TARGET_CLASS = '.co-home-2-cell-frame-2';
      const CHILD_SLIDER_CLASS = '.co-home-2-child-slider';
      const CHILD_CELL_CLASS = '.co-home-2-child-cell';
      const ACTIVE_CLASS = 'active';
      const PREV_CLASS = 'prev';
      const NEXT_CLASS = 'next';
      const IS_SELECTED_CLASS = 'is-selected';
      
      // Animation delay configuration (in milliseconds)
      const ANIMATION_DELAY = 50; // 0.05s delay - adjust as needed

      // Scale configuration - adjust these values as needed
      const SCALE_ACTIVE = 1;    // Scale for centered/active slide
      const SCALE_INACTIVE = 0.8; // Scale for non-centered slides

      // Translation configuration
      const TRANSLATE_START = 0;     // Starting translateX value (0%)
      const TRANSLATE_END_RIGHT = 6; // Ending translateX value for right side (10%)
      const TRANSLATE_END_LEFT = -6; // Ending translateX value for left side (-10%)

      // Drag detection variables
      const viewport = flkty.viewport;

      // Function to find the closest slide to center during drag
      function getClosestSlideIndex() {
        const viewport = flkty.viewport;
        const viewportCenter = viewport.offsetWidth / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;
        
        flkty.cells.forEach((cell, index) => {
          const slide = cell.element;
          const slideRect = slide.getBoundingClientRect();
          const viewportRect = viewport.getBoundingClientRect();
          const slideCenterX = slideRect.left + slideRect.width / 2 - viewportRect.left;
          
          const distanceFromCenter = Math.abs(slideCenterX - viewportCenter);
          
          if (distanceFromCenter < closestDistance) {
            closestDistance = distanceFromCenter;
            closestIndex = index;
          }
        });
        
        return closestIndex;
      }

      // Function to update is-selected class dynamically
      function updateIsSelectedClass(selectedIndex) {
        flkty.cells.forEach((cell, index) => {
          const slide = cell.element;
          if (index === selectedIndex) {
            slide.classList.add(IS_SELECTED_CLASS);
          } else {
            slide.classList.remove(IS_SELECTED_CLASS);
          }
        });
      }

      // Track last updated indices to prevent unnecessary updates
      let lastActiveIndex = -1;
      let lastPrevIndex = -1;
      let lastNextIndex = -1;
      
      // Track pending animation timeouts to prevent duplicate animations
      let pendingAnimationTimeouts = {
        active: null,
        prev: null,
        next: null
      };

      // Function to update active state on child slider with prev/next classes
      function updateChildSliderActive(selectedIndex) {
        const childSlider = document.querySelector(CHILD_SLIDER_CLASS);
        if (!childSlider) return;
        
        const childCells = childSlider.querySelectorAll(CHILD_CELL_CLASS);
        const totalCells = childCells.length;
        
        // Calculate prev and next indices (with wrap-around support)
        const prevIndex = selectedIndex === 0 ? totalCells - 1 : selectedIndex - 1;
        const nextIndex = selectedIndex === totalCells - 1 ? 0 : selectedIndex + 1;
        
        // Only update if there's an actual change
        if (selectedIndex === lastActiveIndex && prevIndex === lastPrevIndex && nextIndex === lastNextIndex) {
          return; // No change needed
        }
        
        // Clear any pending animation timeouts
        Object.values(pendingAnimationTimeouts).forEach(timeout => {
          if (timeout) clearTimeout(timeout);
        });
        pendingAnimationTimeouts = { active: null, prev: null, next: null };
        
        // Remove all classes from all child cells (including animation classes)
        childCells.forEach(cell => {
          cell.classList.remove(ACTIVE_CLASS, PREV_CLASS, NEXT_CLASS, 'active-ani', 'prev-ani', 'next-ani');
        });
        
        // Add active class to the corresponding child cell
        if (childCells[selectedIndex]) {
          childCells[selectedIndex].classList.add(ACTIVE_CLASS);
          // Add delayed animation class
          pendingAnimationTimeouts.active = setTimeout(() => {
            if (childCells[selectedIndex]) {
              childCells[selectedIndex].classList.add('active-ani');
            }
          }, ANIMATION_DELAY);
        }
        
        // Add prev class
        if (childCells[prevIndex]) {
          childCells[prevIndex].classList.add(PREV_CLASS);
          // Add delayed animation class
          pendingAnimationTimeouts.prev = setTimeout(() => {
            if (childCells[prevIndex]) {
              childCells[prevIndex].classList.add('prev-ani');
            }
          }, ANIMATION_DELAY);
        }
        
        // Add next class
        if (childCells[nextIndex]) {
          childCells[nextIndex].classList.add(NEXT_CLASS);
          // Add delayed animation class
          pendingAnimationTimeouts.next = setTimeout(() => {
            if (childCells[nextIndex]) {
              childCells[nextIndex].classList.add('next-ani');
            }
          }, ANIMATION_DELAY);
        }
        
        // Update tracking variables
        lastActiveIndex = selectedIndex;
        lastPrevIndex = prevIndex;
        lastNextIndex = nextIndex;
      }

      // Function to calculate smooth translateX based on distance from center
      function calculateTranslateX(slide, viewport) {
        const slideRect = slide.getBoundingClientRect();
        const viewportRect = viewport.getBoundingClientRect();
        const slideCenterX = slideRect.left + slideRect.width / 2 - viewportRect.left;
        const viewportCenter = viewport.offsetWidth / 2;
        const slideWidth = slideRect.width;
        
        // Calculate distance from center in slide widths
        const distanceFromCenter = (slideCenterX - viewportCenter) / slideWidth;
        
        let translateX = 0;
        
        // Right side animations (positive distances)
        if (distanceFromCenter >= 1 && distanceFromCenter <= 2) {
          // Between next (1) and nextnext (2) positions
          // At distance 1: translateX = 10%
          // At distance 2: translateX = 0%
          const progress = distanceFromCenter - 1; // 0 to 1
          translateX = TRANSLATE_END_RIGHT * (1 - progress);
          
        } else if (distanceFromCenter >= 0 && distanceFromCenter < 1) {
          // Between active (0) and next (1) positions  
          // At distance 0: translateX = 0%
          // At distance 1: translateX = 10%
          translateX = TRANSLATE_END_RIGHT * distanceFromCenter;
          
        // Left side animations (negative distances)
        } else if (distanceFromCenter >= -2 && distanceFromCenter <= -1) {
          // Between prevprev (-2) and prev (-1) positions
          // At distance -2: translateX = 0%
          // At distance -1: translateX = -10%
          const progress = Math.abs(distanceFromCenter) - 1; // 0 to 1
          translateX = TRANSLATE_END_LEFT * (1 - progress);
          
        } else if (distanceFromCenter >= -1 && distanceFromCenter < 0) {
          // Between prev (-1) and active (0) positions
          // At distance -1: translateX = -10%
          // At distance 0: translateX = 0%
          translateX = TRANSLATE_END_LEFT * Math.abs(distanceFromCenter);
        }
        
        return translateX;
      }

      // Function to update slide scales and translations based on their position
      function updateSlideEffects() {
        const viewport = flkty.viewport;
        const viewportCenter = viewport.offsetWidth / 2;
        
        flkty.cells.forEach((cell, index) => {
          const slide = cell.element;
          const scaleTarget = slide.querySelector(SCALE_TARGET_CLASS);
          const translateTarget = slide.querySelector(TRANSLATE_TARGET_CLASS);
          
          // Handle scaling (improved functionality)
          if (scaleTarget) {
            scaleTarget.style.transformOrigin = 'center center';
            
            const slideRect = slide.getBoundingClientRect();
            const viewportRect = viewport.getBoundingClientRect();
            const slideCenterX = slideRect.left + slideRect.width / 2 - viewportRect.left;
            const slideWidth = slideRect.width;
            
            // Calculate distance from center in slide widths (same as translateX logic)
            const distanceFromCenter = Math.abs(slideCenterX - viewportCenter) / slideWidth;
            
            let scale;
            
            if (distanceFromCenter <= 1) {
              // Within 1 slide width from center: smooth scaling from active to inactive
              // At distance 0: scale = 1 (SCALE_ACTIVE)
              // At distance 1: scale = 0.8 (SCALE_INACTIVE)
              const scaleDifference = SCALE_ACTIVE - SCALE_INACTIVE;
              scale = SCALE_ACTIVE - (distanceFromCenter * scaleDifference);
              scale = Math.max(scale, SCALE_INACTIVE);
            } else {
              // Beyond 1 slide width: always inactive scale
              scale = SCALE_INACTIVE;
            }
            
            scaleTarget.style.transform = `scale(${scale})`;
          }
          
          // Handle translation (new functionality)
          if (translateTarget) {
            const translateX = calculateTranslateX(slide, viewport);
            translateTarget.style.transform = `translateX(${translateX}%)`;
          }
        });
      }

      // Click debouncing variables
      let isNavigating = false;
      
      // Function to add click functionality to main slider cells
      function addMainSliderClickFunctionality() {
        // Use Flickity's built-in staticClick event instead of manual click detection
        // This event only fires when user clicks WITHOUT dragging
        flkty.on('staticClick', function(event, pointer, cellElement, cellIndex) {
          // Prevent clicks during navigation
          if (isNavigating) {
            return;
          }
          
          // Navigate to the clicked slide if it's not already selected
          if (cellIndex !== flkty.selectedIndex) {
            isNavigating = true;
            flkty.select(cellIndex);
          }
        });
        
        // Also add visual feedback - cursor pointer on cells
        flkty.cells.forEach((cell) => {
          const slide = cell.element;
          slide.style.cursor = 'pointer';
          
          // Add cursor to child elements too
          const scaleTarget = slide.querySelector(SCALE_TARGET_CLASS);
          const translateTarget = slide.querySelector(TRANSLATE_TARGET_CLASS);
          
          if (scaleTarget) scaleTarget.style.cursor = 'pointer';
          if (translateTarget && translateTarget !== scaleTarget) {
            translateTarget.style.cursor = 'pointer';
          }
        });
      }

      // Drag detection functionality
      flkty.on('dragStart', function() {
        // Add is-drag class when drag transform actually starts
        viewport.classList.add('is-drag');
      });

      flkty.on('dragEnd', function() {
        // Remove is-drag class when drag ends
        viewport.classList.remove('is-drag');
        
        // Add transition for smooth settling
        flkty.cells.forEach(cell => {
          const scaleTarget = cell.element.querySelector(SCALE_TARGET_CLASS);
          const translateTarget = cell.element.querySelector(TRANSLATE_TARGET_CLASS);
          
          if (scaleTarget) {
            scaleTarget.style.transition = 'transform 0.2s ease-out';
          }
          if (translateTarget) {
            translateTarget.style.transition = 'transform 0.2s ease-out';
          }
        });
        updateSlideEffects();
        updateChildSliderActive(flkty.selectedIndex);
        updateIsSelectedClass(flkty.selectedIndex);
      });

      // Initial setup after Flickity is ready
      flkty.on('ready', function() {
        updateSlideEffects();
        updateChildSliderActive(flkty.selectedIndex);
        updateIsSelectedClass(flkty.selectedIndex);
        addMainSliderClickFunctionality();
      });

      // Update effects when slide changes
      flkty.on('select', function() {
        updateSlideEffects();
        updateChildSliderActive(flkty.selectedIndex);
        updateIsSelectedClass(flkty.selectedIndex);
        // Reset navigation flag after slide change completes
        setTimeout(function() {
          isNavigating = false;
        }, 100);
      });

      // Real-time effects during drag
      flkty.on('dragMove', function() {
        updateSlideEffects();
        const closestSlideIndex = getClosestSlideIndex();
        updateChildSliderActive(closestSlideIndex);
        updateIsSelectedClass(closestSlideIndex); // Add dynamic is-selected class update
      });

      // Update when slider moves/scrolls
      flkty.on('scroll', function() {
        updateSlideEffects();
      });

      // Remove transition during drag start for immediate response
      flkty.on('dragStart', function() {
        flkty.cells.forEach(cell => {
          const scaleTarget = cell.element.querySelector(SCALE_TARGET_CLASS);
          const translateTarget = cell.element.querySelector(TRANSLATE_TARGET_CLASS);
          
          if (scaleTarget) {
            scaleTarget.style.transition = 'none';
          }
          if (translateTarget) {
            translateTarget.style.transition = 'none';
          }
        });
      });

      // Add click functionality to child cells to control main slider
      const childSlider = document.querySelector(CHILD_SLIDER_CLASS);
      if (childSlider) {
        const childCells = childSlider.querySelectorAll(CHILD_CELL_CLASS);
        
        childCells.forEach((cell, index) => {
          cell.addEventListener('click', function() {
            flkty.select(index);
          });
        });
      }

      // Call initial functions
      updateSlideEffects();
      updateChildSliderActive(0);
      updateIsSelectedClass(0);

      // Global reference for debugging
      window.flktyDebug = flkty;

    } catch (error) {
      // Silent error handling
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlickityEnhancements);
  } else {
    // DOM is already ready
    initFlickityEnhancements();
  }

  // Fallback for click functionality (separate from main initialization)
  setTimeout(function() {
    if (window.flktyDebug && window.flktyDebug.cells && window.flktyDebug.cells.length > 0) {
      // Check if staticClick event is already bound by checking if we can find existing listeners
      // If not, we need to add the click functionality
      
      // Re-ensure click functionality is working by calling addMainSliderClickFunctionality
      const flkty = window.flktyDebug;
      let isNavigating = false;
      
      // Use Flickity's built-in staticClick event
      flkty.off('staticClick'); // Remove any existing listeners first
      flkty.on('staticClick', function(event, pointer, cellElement, cellIndex) {
        // Prevent clicks during navigation
        if (isNavigating) {
          return;
        }
        
        // Navigate to the clicked slide if it's not already selected
        if (cellIndex !== flkty.selectedIndex) {
          isNavigating = true;
          flkty.select(cellIndex);
          
          // Reset navigation flag
          setTimeout(function() {
            isNavigating = false;
          }, 100);
        }
      });
      
      // Also ensure cursor styling
      flkty.cells.forEach((cell) => {
        const slide = cell.element;
        slide.style.cursor = 'pointer';
        
        const scaleTarget = slide.querySelector('.co-home-2-cell-frame');
        const translateTarget = slide.querySelector('.co-home-2-cell-frame-2');
        
        if (scaleTarget) scaleTarget.style.cursor = 'pointer';
        if (translateTarget && translateTarget !== scaleTarget) {
          translateTarget.style.cursor = 'pointer';
        }
      });
    }
  }, 1000);

  // Single fallback with initialization check
  setTimeout(function() {
    if (!isInitialized) {
      initFlickityEnhancements();
    }
  }, 2000);

})();

// ============================================= ============================================= ============================================= SECTION 6

(function() {
  'use strict';
  
  function setEqualHeights() {
    const titleElements = document.querySelectorAll('.co-home-6-article-title');
    
    if (titleElements.length === 0) return;
    
    titleElements.forEach(el => el.style.height = 'auto');
    
    let maxHeight = 0;
    titleElements.forEach(el => {
      const height = el.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    
    titleElements.forEach(el => {
      el.style.height = maxHeight + 'px';
    });
  }

  const flkty = new Flickity('.co-home-6-slider', {
    pageDots: false, 
    draggable: true,
    prevNextButtons: false,
    cellAlign: "left",
    contain: true,
    on: {
      ready: function() {
        setEqualHeights();
      },
      settle: function() {
        setEqualHeights();
      }
    }
  });
  
  window.addEventListener('resize', function() {
    flkty.resize();
    setEqualHeights();
  });
})();

// ============================================= ============================================= ============================================= SECTION 6

(function() {
  'use strict';
  
  function setEqualHeights() {
    const titleElements = document.querySelectorAll('.co-home-10-cell-frame');
    
    if (titleElements.length === 0) return;
    
    titleElements.forEach(el => el.style.height = 'auto');
    
    let maxHeight = 0;
    titleElements.forEach(el => {
      const height = el.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });
    
    titleElements.forEach(el => {
      el.style.height = maxHeight + 'px';
    });
  }

  const flkty = new Flickity('.co-home-10-slider', {
    pageDots: false, 
    draggable: true,
    prevNextButtons: false,
    cellAlign: "left",
    contain: true,
    on: {
      ready: function() {
        setEqualHeights();
      },
      settle: function() {
        setEqualHeights();
      }
    }
  });
  
  window.addEventListener('resize', function() {
    flkty.resize();
    setEqualHeights();
  });
})();